export default __webpack_public_path__ + "static/media/darren.be007e86.png";